export default "__VITE_ASSET__3195fd2e__"